import React, { useState, useEffect } from "react";
import axios from "axios";
import { API, useAuth } from "../App";
import Stories from "../components/Stories";
import FeedCard from "../components/FeedCard";
import { Skeleton } from "../components/ui/skeleton";

const HomePage = () => {
  const { token } = useAuth();
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState(null);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const params = selectedCategory ? { category: selectedCategory } : {};
        const response = await axios.get(`${API}/projects`, { 
          params,
          headers: { Authorization: `Bearer ${token}` }
        });
        setProjects(response.data);
      } catch (error) {
        console.error("Failed to fetch projects:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
  }, [token, selectedCategory]);

  return (
    <div className="min-h-screen bg-black" data-testid="home-page">
      {/* Stories */}
      <Stories 
        onCategorySelect={setSelectedCategory} 
        selectedCategory={selectedCategory}
      />

      {/* Feed */}
      <div className="divide-y divide-white/10">
        {loading ? (
          // Skeleton loading
          Array.from({ length: 3 }).map((_, i) => (
            <div key={i} className="pb-6">
              <div className="flex items-center gap-3 p-4">
                <Skeleton className="w-10 h-10 rounded-full bg-zinc-800" />
                <div className="space-y-2">
                  <Skeleton className="h-3 w-24 bg-zinc-800" />
                  <Skeleton className="h-2 w-16 bg-zinc-800" />
                </div>
              </div>
              <Skeleton className="aspect-[4/5] w-full bg-zinc-800" />
              <div className="p-4 space-y-3">
                <Skeleton className="h-4 w-32 bg-zinc-800" />
                <Skeleton className="h-3 w-full bg-zinc-800" />
                <Skeleton className="h-3 w-2/3 bg-zinc-800" />
              </div>
            </div>
          ))
        ) : projects.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-20 text-white/60">
            <p className="text-lg mb-2">Nessun progetto trovato</p>
            <p className="text-sm">
              {selectedCategory 
                ? "Prova a selezionare un'altra categoria" 
                : "I lavori saranno pubblicati presto"
              }
            </p>
          </div>
        ) : (
          projects.map((project) => (
            <FeedCard key={project.id} project={project} />
          ))
        )}
      </div>
    </div>
  );
};

export default HomePage;
